module.exports = __webpack_public_path__ + "assets/actionCovidMobile.b2ceb530.svg";